import React from 'react';
import draftToHtml from 'draftjs-to-html';
import ReactHtmlParser from 'react-html-parser';

const DescField = (props) => {
    return (
        <div className='text-block'>
            {ReactHtmlParser(draftToHtml(props.textFields))}
        </div>
    )
}
export default DescField;